import { initVueApp } from '../../../../../app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import initTree from '../../../../../app/assets/javascripts/repository/index.js?vue3';
import repositoryPathMixin from '~/repository/mixins/repository_path';
import CodeOwners from '../vue_shared/components/code_owners/code_owners.vue?vue3';

const initCodeOwnersApp = (router, apolloProvider, projectPath) => {
  const codeOwnersEl = document.querySelector('#js-code-owners');
  if (!codeOwnersEl) return null;

  const { branch, canViewBranchRules, branchRulesPath } = codeOwnersEl.dataset;
  return initVueApp({
    el: codeOwnersEl,
    name: 'RepositoryCodeOwnersRoot',
    router,
    apolloProvider,
    component: {
      name: 'RepositoryCodeOwnersApp',
      mixins: [repositoryPathMixin],
      render(h) {
        return h(CodeOwners, {
          props: {
            filePath: this.computedPath,
            projectPath,
            branch,
            canViewBranchRules,
            branchRulesPath,
          },
        });
      },
    },
  });
};

export default () => {
  const tree = initTree();
  if (!tree) return;

  const { router, apolloProvider, projectPath } = tree;

  initCodeOwnersApp(router, apolloProvider, projectPath);
};
